import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import Icon from 'assets/components/icon/Icon';
import { addProgressToWindow } from 'assets/components/progressWindow/ProgressWindow';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { isEmpty } from 'lodash';
import { isMobile } from 'react-device-detect';
import { SalesContractVertaforeSyncType, useSalesContractProvider } from '../Sales.Contract.Hooks';

export default function SalesContractActions() {
  const { lang } = getLocales();
  const {
    listApi,
    permissions,
    contractUnknownVertaforeStatusListApi,
    contractNotUploadedVertaforeStatusListApi,
    exportContractsToExcel,
    syncAllWithVertafore,
    resendAllForSigning,
    reuploadAllSignedDocuments,
    isFetchingEnvelopes,
    selectedContracts,
    hasMixedDealers,
    createStatementFromSelectedContracts,
  } = useSalesContractProvider();

  return (
    <>
      <DropdownButton
        buttonMedia={<Icon class="fas-sync" />}
        horizontalPosition="auto_fixed"
        verticalPosition="auto_fixed"
        subcomponents={ThemeDropdownButtonPopup}
        buttonBody={lang.syncWithVertafore}
        htmlElementProps={{ title: lang.syncAllWithVertafore }}
        title={lang.syncAllWithVertafore}
        disabled={!permissions.VERTAFORE_SYNC_CONTRACT}
        tabIndex={null}
        dropdownOptions={() => {
          return (
            <>
              <Button
                class={ThemeButtonMenuItem}
                media={<Icon class="fas-sync" />}
                render={lang.contracts}
                onClick={({ addProgressToWindow, syncType }) => syncAllWithVertafore(addProgressToWindow, syncType)}
                data={{ addProgressToWindow, syncType: SalesContractVertaforeSyncType.SYNC_CONTRACTS }}
                disabled={
                  !permissions.VERTAFORE_SYNC_CONTRACT || isEmpty(contractUnknownVertaforeStatusListApi?.payload)
                }
              />
              <Button
                class={ThemeButtonMenuItem}
                media={<Icon class="fas-sync" />}
                render={lang.contractsDocumentationAggregate}
                onClick={({ addProgressToWindow, syncType }) => syncAllWithVertafore(addProgressToWindow, syncType)}
                disabled={
                  !permissions.VERTAFORE_SYNC_CONTRACT || isEmpty(contractNotUploadedVertaforeStatusListApi?.payload)
                }
                data={{ addProgressToWindow, syncType: SalesContractVertaforeSyncType.SYNC_CONTRACT_DOCUMENTS }}
              />
            </>
          );
        }}
      />
      <DropdownButton
        buttonMedia={<Icon class="fas-sync" />}
        horizontalPosition="auto_fixed"
        verticalPosition="auto_fixed"
        subcomponents={ThemeDropdownButtonPopup}
        buttonBody={lang.docusignOptions}
        htmlElementProps={{ title: lang.docusignOptions }}
        title={lang.docusignOptions}
        disabled={!(permissions?.SEND_CONTRACT_FOR_SIGNING || permissions?.REUPLOAD_SIGNED_CONTRACTDOCUMENT)}
        tabIndex={null}
        dropdownOptions={({ animateOut }) => {
          return (
            <>
              <Button
                class={ThemeButtonMenuItem}
                media={<Icon class="fas-sync" />}
                render={!isMobile && lang.resendForSigning}
                isLoading={isFetchingEnvelopes}
                onClick={(data) => {
                  animateOut();
                  resendAllForSigning(data);
                }}
                data={addProgressToWindow}
                disabled={!permissions.SEND_CONTRACT_FOR_SIGNING || isEmpty(listApi?.payload?.data)}
              />
              <Button
                class={ThemeButtonMenuItem}
                media={<Icon class="fas-sync" />}
                render={!isMobile && lang.reuploadSignedDocuments}
                isLoading={isFetchingEnvelopes}
                onClick={(data) => {
                  animateOut();
                  reuploadAllSignedDocuments(data);
                }}
                data={addProgressToWindow}
                disabled={!permissions.REUPLOAD_SIGNED_CONTRACTDOCUMENT || isEmpty(listApi?.payload?.data)}
              />
            </>
          );
        }}
      />
      <Button
        class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
        active
        media={<Icon class="fas-download" />}
        render={!isMobile && lang.export}
        onClick={exportContractsToExcel}
        disabled={!permissions.CREATE_CONTRACT || isEmpty(listApi?.payload?.data)}
      />
      <Button
        class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
        active
        media={<Icon class="fas-file" />}
        render={!isMobile && lang.createStatement}
        onClick={createStatementFromSelectedContracts}
        disabled={
          selectedContracts?.length === 0 || hasMixedDealers || !permissions.CREATE_STATEMENTS_FROM_CONTRACT_LIST
        }
        htmlElementProps={{
          title:
            selectedContracts?.length === 0
              ? lang.selectAtLeastOneContract
              : hasMixedDealers
                ? lang.contractsMustBelongToSameDealer
                : !permissions.CREATE_STATEMENTS_FROM_CONTRACT_LIST
                  ? lang.missingPermission
                  : lang.createStatement,
        }}
      />
    </>
  );
}
